<template lang="pug">
.v-media-content.media-content(v-if="data" :class="'media-content--' + direction" :id="data?.id")
	.media-content__body(:id="uniqueId")
		.media-content__media(v-if="data.items")
			.media-content__slider
				v-base-slider(:options="options" theme="dark" :class="[data.items?.length < 2 ? 'disable-buttons' : '']")
					v-swiper-slide.media-content__slide.swiper-slide(v-for="slide in data.items")
						v-video-card(v-if="slide.video" :card="{video: slide.video, image: slide.video.image}")
						img.media-content__slide-img(v-else-if="slide.image" :src="slide.image.src" :alt="slide.image.alt")
		.media-content__content
			.text-guide
				h3.h3(v-if="data.title" v-html="data.title")
				p(v-if="data.text" v-html="data.text")
				component(v-if="data.list" :is="data.list.type === 'ol' ? 'ol' : 'ul'")
					li(v-for="item in data.list.items" v-html="item.text")
	.media-content__actions(v-if="data.actions")
		a.btn.btn--primary(v-for="action in data.actions" :href="action.link") {{ action.text }}
</template>

<script>

import sourceMixin from "./mixins/v-mixin-source.vue";
import {SwiperSlide} from 'swiper/vue';
import breakpoints from "../scripts/breakpoints.js";
import uniqueId from '../scripts/helpers/uniqueId.js';

export default {

	components: {
		'v-swiper-slide': SwiperSlide
	},

	mixins: [
		sourceMixin
	],

	props: {
		direction: {
			type: String,
			default: 'left'
		}
	},

	data() {
		return {
			data: null,
			uniqueId: uniqueId('swiper-'),
		}
	},

	computed: {
		options() {
			return {
				slidesPerView: 1,
				spaceBetween: 12,
				watchOverflow: true,
				loop: this.data.items?.length > 1,
				pagination: {
					clickable: true,
					el: `#${this.uniqueId} .swiper-pagination`,
					dynamicBullets: false
				},
				breakpoints: {
					[breakpoints['tablet']]: {
						slidesPerView: 1,
						spaceBetween: 32,
						navigation: {
							prevEl: `#${this.uniqueId} .swiper-button-prev`,
							nextEl: `#${this.uniqueId} .swiper-button-next`
						}
					}
				},
			}
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
}

</script>
